import classNames from 'classnames';
import React from 'react';
import addIcon from '../icons/non-prefilled/16x16/add.svg';
import trashIcon from '../icons/non-prefilled/16x16/trash.svg';
import Avatar from './Avatar';
import { AvatarContainer, AvatarStackContainer } from './AvatarStack';
import * as styles from './AvatarStackEditable.module.scss';
import SVGIcon from './SVGIcon';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const AVATAR_STACK_EDITABLE_USERS_FRAGMENT = gql(`
  fragment AvatarStackEditable_users on User {
    id
    ...Avatar_user
  }
`);

interface EditableAvatarStackProps {
  users: DocumentType<typeof AVATAR_STACK_EDITABLE_USERS_FRAGMENT>[];
  size?: number;
  noWrap?: boolean;
  onAdd: () => void;
  onRemove: (userId: string) => void;
}

const AvatarStackEditable = ({
  users,
  size = 32,
  noWrap,
  onAdd,
  onRemove,
}: EditableAvatarStackProps) => {
  const removeSize = Math.ceil(size * 0.8);
  const removeIconSize = removeSize - 2 * Math.ceil(removeSize * 0.2);

  return (
    <AvatarStackContainer visibleUsers={users} noWrap={noWrap}>
      {users.map((user, i) => (
        <div key={user.id} className={classNames(styles.avatar)}>
          <AvatarContainer index={i}>
            <Avatar size={size} user={user} />
          </AvatarContainer>
          <button
            className={styles.removeIcon}
            style={{
              top: size / 2,
              right: removeIconSize,
              height: removeSize,
              width: removeSize,
            }}
            onClick={() => onRemove(user.id)}
            type="button"
          >
            <SVGIcon size={removeIconSize}>{trashIcon}</SVGIcon>
          </button>
        </div>
      ))}

      <button
        className={styles.addButton}
        style={{ height: size, width: size }}
        onClick={() => onAdd()}
        type="button"
      >
        <SVGIcon size={size / 2}>{addIcon}</SVGIcon>
      </button>
    </AvatarStackContainer>
  );
};

export default AvatarStackEditable;
